export const environment = {
  production: false,
  indexer: {
    token: {
      'X-API-Key': 'BtYg0Xyisl2oxmELrQeBz1h6pLEIhdYI7DsDSAgj',
    },
    server: 'https://testnet-algorand.api.purestake.io/idx2',
    port: '',
  },
  ipfsGateway: 'https://ipfs.io/ipfs/',
  pack: {
    creator: 'CIDB53FJ3BLOBZ5DL63YWMLQCBA4WL46FIA6VLBBN3ZHHB6JEJXAMAO3D4',
    unitName: 'TT-LBCF',
    manager: 'CIDB53FJ3BLOBZ5DL63YWMLQCBA4WL46FIA6VLBBN3ZHHB6JEJXAMAO3D4',
  },
  srcUrl: 'https://dev-src.trantorian.network',
};
